import base from "/Users/a/Desktop/Code/frontend/monochrome/images/sort.svg?svg";
import { getResizer } from "svg-merge-attributes";
export default getResizer(base, "");